import { cn } from "@/shared/libs/commonUtils";
import { Dialog, DialogTrigger, DialogContent, DialogTitle } from "../Dialog";
import { ReactNode } from "react";

export default function ImageGalleryModal({
  children,
  content,
  className,
}: {
  children: ReactNode;
  content: ReactNode;
  className?: string;
}) {
  return (
    <Dialog>
      <DialogTrigger className={cn("w-full h-full", className)}>
        {children}
      </DialogTrigger>
      <DialogContent className="max-w-[800px] p-1 rounded-xs! overflow-hidden">
        <DialogTitle className="hidden" />
        {content}
      </DialogContent>
    </Dialog>
  );
}
